var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.users),function(user,index){return _c('v-col',{key:index,attrs:{"cols":_vm.$vuetify.breakpoint.mdAndUp ? 3 : 12}},[_c('challenger-detail-community-user',{attrs:{"user":user}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }